import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'
// import md5 from 'js-md5'
import jsSHA from 'jssha'

/* 別Storeへの参照方法
 * state     : this.state.scoopMarketFilters.xxxxx
 * getters   : this.getters['scoopMarketFilters/xxxxx']
 * actions   : this.dispatch('scoopMarketFilters/xxxxx', parameters)
 * mutations : this.commit('scoopMarketFilters/xxxxx', parameters)
 */

const state = {
  authorized: false,
  userModel: {},
  // 管理者区分
  role: null,
  // 仮パスワードから変更されていればfalse
  requireChangePassword: true,
  // 前回2段階認証実施日時
  mfaConfirmedAt: 0,
}

const getters = {
  get: state => state,

  // ログインユーザー情報
  userIdentity: state => state.userModel.userUuid,
  userName: state => state.userModel.name,
  roleName: state => Utility.getConstantsLabel(['UserRole'], state.role),

  // 権限 : システム管理者
  isAdmin: state => state.role === 1,
  // 権限 : サービス運用担当者
  isOperator: state => state.role === 2,
  // 権限 : 外部連携CMS担当者
  isExternal: state => state.role === 4,

  // サービス運用者の連携しているサービスUUIDを返す
  userServiceUuid:state => state.userModel.service
    ? state.userModel.service.serviceUuid
    : null,
}

const actions = {
  /**
   * ログイン
   */
  signin ({commit}, {loginId, password}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['auth'],
        ['v1Login'],
        [{
          loginId: loginId,
          loginPassword: password
        }])
        .then(res => {
          console.log('success', res);
          let status = Utility.parseResponse(res)

          if (status.result) {
            // md5のハッシュを生成
            let userUuid = res[0].data.user.userUuid
            let role = res[0].data.user.roleKbn
            let mfaConfirmedAt = res[0].data.user.mfaConfirmedAt || 0
            let passwordChanged = res[0].data.user.passwordChanged
            let timestamp = res[0].data.timestamp
            // let secretKey = window._API_.sk
            let secretKey = process.env.VUE_APP_KEY
            let serverHash = res[0].data.hash
            let str = userUuid + role + mfaConfirmedAt + passwordChanged + timestamp + secretKey

            // md5でハッシュ化
            // let clientHash = md5(str)

            // SHA-256でハッシュ化
            const shaObj = new jsSHA('SHA-256', 'TEXT', { encoding: 'UTF8' })
            shaObj.update(str)
            let clientHash = shaObj.getHash('HEX')
            
            console.log('secretKey', secretKey)
            console.log('serverHash', serverHash)
            console.log('clientHash', clientHash)
            
            // ハッシュ認証成功
            if (serverHash === clientHash) {
              commit('signined', res[0].data)
              // console.log('userModel', state.userModel)

              // 表示権限を設定
              this.dispatch('auth/setPermission')

              resolve(res)
              
            // ハッシュ認証失敗
            } else {
              reject([
                {
                  status: 400,
                  data: {
                    errors: [
                      {
                        code: "9999",
                        message: "レスポンスに異常が認められました。"
                      }
                    ]
                  }
                }
              ])
            }
            
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * 二段階認証
   */
  verify ({commit}, {code}) {
    console.log('verify')
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['auth'],
        ['v1Verification'],
        [{
          code: code
        }])
        .then(res => {
          console.log('success', res);
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('verified')

            // 表示権限を設定
            this.dispatch('auth/setPermission')

            resolve(res)
            
          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          console.log('error', error.response);
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * 前回二段階認証から24時間経っていなかったときに呼ぶ
   */
  setPreviousAuth({commit}) {
    commit('verified')
    // 表示権限を設定
    this.dispatch('auth/setPermission')
  },
  /**
   * ログアウト
   */
  signout ({commit}) {
    return new Promise((resolve) => {
      commit('signouted')
      // this.dispatch('permission/reset')
      resolve()
    })
  },

  /**
   * 表示権限を設定
   */
  setPermission ({commit, getters}) {
    this.dispatch('permission/set', {
      isAdmin: getters.isAdmin,
      isOperator: getters.isOperator,
      isExternal: getters.isExternal
    })
  },

  /**
   * パスワード変更セットアップ完了
   */
  completeSetup ({commit}, data) {
    commit('completedSetup', data)
  },

  /**
   * ローカルストレージにユーザー情報が保持されているかチェック
   */
  checkAuth ({commit}) {
    return new Promise((resolve, reject) => {
      if (window.localStorage.user) {
        const data = JSON.parse(window.localStorage.user);
        if (data.role === 2) {
          ApiManager.request(
            ['user'],
            ['v1UserAccountGet'],
            [{
              targetId: window.localStorage.user.userUuid,
              userParams: {
                AccountId: window.localStorage.user.userUuid
              }
            }])
            .then(res => {
              let status = Utility.parseResponse(res)
              if (status.result) {
                data.videoChatCmsSetting = res[0].data.videoChatCmsSetting
                data.service = res[0].data.service;
                window.localStorage.user = JSON.stringify(data)
                commit('checkedAuth', window.localStorage.user)
                // 表示権限を設定
                this.dispatch('auth/setPermission')

                if (state.requireChangePassword) {
                  resolve('SetupPassword')
                } else {
                  resolve()
                }
              } else {
                commit('checkedAuth', window.localStorage.user)

                if (state.requireChangePassword) {
                  resolve('SetupPassword')
                } else {
                  resolve()
                }
              }
            })
            .catch(error => {
              commit('checkedAuth', window.localStorage.user)

              if (state.requireChangePassword) {
                resolve('SetupPassword')
              } else {
                resolve()
              }
            })

        } else {
          commit('checkedAuth', window.localStorage.user)

          if (state.requireChangePassword) {
            resolve('SetupPassword')
          } else {
            resolve()
          }
        }

      } else {
        reject()
      }
    })
  },

  /**
   * 新しいパスワードを登録
   */
  // updatePassword ({commit}, {token, email, password}) {
  //   return new Promise((resolve, reject) => {
  //     ApiManager.request(
  //       ['auth'],
  //       ['v1AuthReminderUpdate'],
  //       [{
  //         PasswordRestUrlToken: token,
  //         Email: email,
  //         NewPassword: password
  //       }])
  //       .then(res => {
  //         if (res[0].data.Result === 'success') {
  //           commit('signined', res[0].data.User)
  //           resolve(res)
            
  //         } else {
  //           reject(res[0].data)
  //         }
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },

  // お知らせ配信管理から認証情報を保存
  setFromBot ({commit}, data) {
    commit('setFromBot', data)
    // 表示権限を設定
    this.dispatch('auth/setPermission')
  }
}

const mutations = {
  // 認証
  signined (state, data) {
    // ストレージに認証情報を保存
    let info = {
      accessToken: data.accessToken,
      userUuid: data.user.userUuid,
      registered: data.user.passwordChanged,
      role: data.user.roleKbn,
      name: data.user.name,
      service: data.user.service
    }
    window.sessionStorage.user = JSON.stringify(info)

    // 
    state.requireChangePassword = !data.user.passwordChanged
    state.mfaConfirmedAt = data.user.mfaConfirmedAt

    // stateの切替
    // Vue.set(state, 'userModel', info)
    // state.role = state.userModel.role
    // state.requireChangePassword = !state.userModel.registered

    // 認証済フラグ
    // state.authorized = true
  },
  // 二段階認証完了
  verified (state) {
    // アカウント情報をsessionStorageからlocalStorageに移管
    window.localStorage.user = window.sessionStorage.user

    // stateの更新
    let info = JSON.parse(window.localStorage.user)
    Vue.set(state, 'userModel', info)
    state.role = state.userModel.role
    state.requireChangePassword = !state.userModel.registered

    // アカウント情報をsessionStorageから削除
    window.sessionStorage.removeItem('user')

    // 認証済フラグ
    state.authorized = true
  },
  signouted (state) {
    // ストレージの認証情報を削除
    window.sessionStorage.removeItem('user')
    window.localStorage.removeItem('user')

    // stateを初期化
    Vue.set(state, 'userModel', {})
    state.role = null
    state.requireChangePassword = true

    // 認証済フラグ
    state.authorized = false
  },

  // セットアップ
  completedSetup (state, data) {
    // ストレージに認証情報を保存
    let info = {
      accessToken: data.accessToken,
      userUuid: data.user.userUuid,
      registered: true,
      role: data.user.roleKbn,
      name: data.user.name,
      service: data.user.service
    }
    window.sessionStorage.user = JSON.stringify(info)

    // 
    state.requireChangePassword = false

    // stateの更新
    // Vue.set(state, 'userModel', info)
    // state.role = state.userModel.role
    // state.requireChangePassword = !state.userModel.registered
  },

  // 認証チェック
  checkedAuth (state, data) {
    // stateの更新
    Vue.set(state, 'userModel', JSON.parse(data))
    state.role = state.userModel.role
    state.requireChangePassword = !state.userModel.registered

    // 認証済フラグ
    state.authorized = true
  },

  // お知らせ配信管理から認証情報を保存
  setFromBot(state, data) {
    // ストレージに認証情報を保存
    window.localStorage.user = JSON.stringify({
      accessToken: data.accessToken,
      // userUuid: data.userUuid,
      registered: true,
      role: 2,
      // name: data.name,
      service: {
        serviceName: data.serviceBasicInfo.serviceName,
        serviceUuid: data.serviceBasicInfo.serviceUuid
      }
    })

    // stateの更新
    let info = JSON.parse(window.localStorage.user)
    Vue.set(state, 'userModel', info)
    state.role = state.userModel.role
    state.requireChangePassword = !state.userModel.registered

    // 認証済フラグ
    state.authorized = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
